<template>
    <div class="verified-input">
        <VerifiedLable
            :id="id"
            :title="title"
            :tagnewid="tagnewid"
            :required="required"
            :disableMLtitle="disableMLtitle"
            :tooltipLabel="tooltipLabel"
            :tooltipPosition="tooltipPosition"
            :tooltipType="tooltipType"
            :tooltipSize="tooltipSize"
            :tooltipMultilined="tooltipMultilined"
        />
        <v-select
            ref="selectInput"
            :options="options"
            :pageOptions="pageOptions"
            :value="value"
            @search="search"
            @observer="observer"
            @input="onChange"
            :label="label"
            :loading="loading"
            :paginate="paginate"
            :totalResults="totalResults"
            :placeholder="disableMLplaceholder ? placeholder : getTranslation(placeholder, '')"
            :clearable="noclear"
            :class="{ invalid: focusedOut && invalid, smaller: smaller }"
            :disabled="disabled"
            :selectHeight="height"
        >
            <template slot="no-options">
                {{ $t('sem-resultados-filtro') }}
            </template>
            <template slot="option" slot-scope="option">
                <slot name="option" :bind="option">
                    {{ option[label] }}
                </slot>
            </template>
            <template slot="selected-option" slot-scope="option">
                <slot name="selected-option">
                    <div class="selected" :title="option[label]">
                        {{ option[label] }}
                    </div>
                </slot>
            </template>
        </v-select>
        <span class="validation" v-text="getTranslation(msg, '')" v-if="focusedOut && invalid" />
    </div>
</template>

<script>
// vs-select

import VerifiedLable from '@/components/shared/VerifiedLable.vue';

export default {
    components: {
        VerifiedLable,
    },
    props: {
        value: {
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        stylized: {
            type: Boolean,
            default: false,
        },
        options: {
            type: Array,
            default: () => [],
        },
        pageOptions: {
            type: Array,
            default: () => [],
        },
        onChange: {
            type: Function,
            default: (val) => {
                if (this != undefined) {
                    this.$emit('input', val);
                }
            },
        },
        focusin: {
            type: Function,
            default: (val) => {},
        },
        keydown: {
            type: Function,
            default: (val) => {},
        },
        search: {
            type: Function,
            default: () => {},
        },
        paginate: {
            type: Boolean,
            default: false,
        },
        totalResults: {
            type: Number,
            default: 0,
        },
        observer: {
            type: Function,
            default: () => {},
        },
        id: {
            default: new Date().getTime(),
        },
        placeholder: {
            default: '',
            type: String,
        },
        title: {
            default: '',
            type: String,
        },
        label: {
            default: 'label',
            type: String,
        },
        msg: {
            default: 'msg-campo-obrigatorio',
            type: String,
        },
        invalid: {
            default: false,
            type: Boolean,
        },
        onBlur: {
            default: true,
            type: Boolean,
        },
        nextEl: {
            default: null,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        noclear: {
            type: Boolean,
            default: false,
        },
        smaller: {
            type: Boolean,
            default: false,
        },
        disableMLtitle: {
            type: Boolean,
            default: false,
        },
        // Id do tagnew referente ao .env na raiz do sistema
        tagnewid: undefined,
        // O título fica com a cor primária da empresa e com um asterisco após o título
        required: {
            type: Boolean,
            default: false,
        },
        /* Caso tenha uma informação adicional sobre o campo */
        tooltipLabel: {
            type: String,
            default: null,
        },
        tooltipPosition: {
            type: String,
            default: 'is-right',
        },
        tooltipType: {
            type: String,
            default: 'is-dark',
        },
        tooltipMultilined: {
            type: Boolean,
            default: true,
        },
        tooltipSize: {
            type: String,
            default: 'is-large',
        },
        height: {
            type: Number,
            default: 36,
        },
        disableMLplaceholder: {
            type: Boolean,
            default: false,
        },
    },

    mounted() {
        this.focusedOut = !this.onBlur;

        let inputSearch = this.$refs.selectInput.$refs.search;
        inputSearch.addEventListener('focusin', () => this.focusin());
        inputSearch.addEventListener('keydown', this.keydown);
        inputSearch.addEventListener('blur', this.validateOnBlur);

        let selectedOptions = this.$refs.selectInput.$refs.selectedOptions;
        selectedOptions.addEventListener('click', this.clickListener);
    },
    data() {
        return {
            focusedOut: false,
        };
    },

    methods: {
        getOptionLabel(value) {
            this.$refs.selectInput.getOptionLabel(value);
        },
        validateOnBlur() {
            if (this.onBlur) {
                this.focusedOut = true;
                if (this.nextEl) this.nextEl.focus();
            }
            // para quando quiser apenas saber se foi executado o blur
            this.$emit('onBlurFunction');
        },
        typeAheadSelect() {
            this.$refs.selectInput.typeAheadSelect();
        },
        focus() {
            this.$refs.selectInput.$refs.search.focus();
        },
        clickListener(e) {
            if (!this.value) {
                return;
            }

            let exclusions = ['vs__selected', 'vs__selected-options', 'vs__selected'];

            if (!exclusions.includes(e.target.className) && !this.$refs.selectInput.disabled) {
                this.$refs.selectInput.open = !this.$refs.selectInput.open;

                if (this.$refs.selectInput.open) {
                    this.$refs.selectInput.$refs.search.focus();
                } else {
                    this.$refs.selectInput.$refs.search.blur();
                }
            }
        },
    },
};
</script>

<style lang="scss">
.nova-parametrizacao-select ul {
    max-height: 200px;
}

span.validation {
    font-size: 8px;
    color: $red;
    display: block;
    font-weight: 600;
}

.invalid > div.vs__dropdown-toggle {
    border: 1px solid $red-alert !important;
}

input {
    margin-bottom: 0 !important;
}

.v-select {
    min-height: 36px;
}
.v-select input {
    height: 24px;
}

.v-select .vs__selected-options {
    align-items: center;
}

.v-select.vs--single {
    .vs__selected-options {
        flex-wrap: nowrap;
        flex-basis: auto;
    }
    .selected,
    .vs__selected-options .selected {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    &.vs--single .vs__selected {
        width: calc(100%);
    }
}
</style>
